<zef-form-field *ngIf="mode === httpRoutingFieldsModes.Normal">
  <zef-autocomplete-tag-field
    [showPanel]="false"
    [hint]="translations.hostHint"
    [label]="translations.hostLabel"
    [disableAutocomplete]="true"
    [blacklist]="domainsBlacklist"
    (optionAdded)="domainSelected.emit($event)"
    (blacklisted)="domainBlacklisted.emit($event)"
    [tagSearchPlaceholder]="translations.hostPlaceholder"
    [isInvalid]="domainsControl?.isInvalid && (domainsControl?.isTouched || domainsControl?.isSubmitted)"
    [ngrxFormControlState]="domainsControl">
  </zef-autocomplete-tag-field>
</zef-form-field>

<div class="fx:pb-1">

  <zef-form-field appearance="slide-toggle" *ngIf="mode === httpRoutingFieldsModes.Normal">
    <div class="__ssl-toggle-wrap">
      <mat-slide-toggle
        [ngrxFormControlState]="sslControl"
        class="__ssl-toggle">
        Automatically install SSL Certificates
      </mat-slide-toggle>
    </div>
  </zef-form-field>

  <zef-form-field appearance="slide-toggle" *ngIf="mode === httpRoutingFieldsModes.Normal">

    <div class="__cdn-toggle-wrap">
      <mat-slide-toggle
        [ngrxFormControlState]="cdnControl"
        class="__cdn-toggle">
        Enable CDN for static files
      </mat-slide-toggle>
    </div>

    <zef-form-hints class="__cdn-toggle-hint">
      <zui-docs-text>
        A <span>staticCdnUrl</span> environment variable will be added at project level.
        Use it as the path for your static files to serve them via <a data-zui-new-docs="features/cdn">CDN</a>,
        e.g. <span [innerHTML]="'${staticCdnUrl}/example.com/uploads/image.png'"></span>.
      </zui-docs-text>
    </zef-form-hints>

  </zef-form-field>

</div>

<span class="__location-control-label"><strong>Location rules</strong> <br/>Use the cog icon to configure advanced settings like redirects, <br/> basic auth, rate limiting or access policy.</span>

@for (ctrl of locationsControl?.controls; track ctrl.id; let index = $index) {
  <div class="__location-control">
    <div class="__location-control-grid">

      <div class="__location-control-grid-item">
        <div class="fx:relative">

          <zef-form-field class="__form-field">
            <mat-form-field
              color="accent"
              class="__location-form-field">
              <mat-label>Public Path</mat-label>

              <span matPrefix>{{ '{domain}' }}</span>

              <input
                matInput
                zuiAutofocus
                [ngrxFormControlState]="ctrl.controls.path"
                [ngrxEnableFocusTracking]="true"
                type="text"
              />
            </mat-form-field>
          </zef-form-field>

          <div class="__location-buttons  __location-buttons--left">
            @if (locationsControl?.controls?.length > 1) {
              <button
                class="__remove-location-button"
                type="button"
                (click)="removeLocation.emit(index)"
                mat-icon-button>
                <mat-icon>close</mat-icon>
              </button>
            }
          </div>

        </div>
      </div>

      <div class="u-text--center">
        <mat-icon class="__location-arrow-icon">arrow_right_alt</mat-icon>
      </div>

      <div class="__location-control-grid-item">
        <div class="fx:relative">

          <zef-form-field class="__form-field">
            <mat-form-field
              color="accent"
              class="__location-form-field">

              <mat-label>Service + Port</mat-label>

              <mat-select
                [placeholder]="'Select service..'"
                [ngrxFormControlState]="ctrl.controls.portData"
                [compareWith]="compareFn">
                @for (item of portsWithServiceStackInfo; track $index) {
                  <mat-optgroup [label]="item[0]?.serviceStackName">
                    @for (portItem of item; track $index) {
                      <mat-option [value]="portItem">
                        {{ portItem.serviceStackName }}:{{ portItem.port }}
                      </mat-option>
                    }
                  </mat-optgroup>
                }
              </mat-select>

            </mat-form-field>
          </zef-form-field>

          <div class="__location-buttons  __location-buttons--right">
            <button
              [matTooltip]="'Advanced configuration for the location, like redirects, basic auth and rate limiting.'"
              [matTooltipClass]="'c-zerops-tooltip'"
              [matTooltipPosition]="'above'"
              [class.has-active]="ctrl?.controls?.config?.controls?.redirect?.controls?.enabled?.value
                || ctrl?.controls?.config?.controls?.basicAuth?.controls?.enabled?.value
                || ctrl?.controls?.config?.controls?.accessPolicy?.controls?.enabled?.value
                || ctrl?.controls?.config?.controls?.rateLimiting?.controls?.enabled?.value
                || ctrl?.controls?.config?.controls?.content?.controls?.enabled?.value"
              class="__advanced-config-location-button"
              type="button"
              (click)="openAdvancedConfig(index)"
              mat-icon-button>
              <mat-icon fontSet="material-icons-outlined">settings</mat-icon>
              <span class="__advanced-config-location-button_status"></span>
            </button>
          </div>

        </div>
      </div>

    </div>
  </div>
}

<zef-dialog
  [open]="dialogOpen"
  [autoFocus]="false"
  (closeTrigger)="closeAdvancedConfig()">

  <div class="__advanced-dialog-content">

    <button
      class="__dialog-close-button"
      type="button"
      mat-icon-button
      (click)="closeAdvancedConfig()">
      <mat-icon>close</mat-icon>
    </button>

    <zef-scrollbar [maxHeight]="'800px'" [height]="'calc(85vh - 86px)'">
      @if (activeLocationConfiguration !== undefined) {
        <zef-form
          [state]="locationsControl?.controls[activeLocationConfiguration]?.controls.config"
          class="__advanced-config-form __dialog-inner-content">

          <div class="__location-context">
            <zui-routing-location-item
              disableLink="true"
              showDomainPlaceholder="true"
              [domains]="domainsControl?.value?.value"
              [path]="locationsControl?.controls[activeLocationConfiguration]?.controls?.path?.value || '/'"
              [serviceStackName]="getServiceStackName(
                locationsControl?.controls[activeLocationConfiguration]?.controls?.portData?.value?.value?.serviceStackId,
                locationsControl?.controls[activeLocationConfiguration]?.controls?.portData?.value?.value?.port
              )"
              [port]="locationsControl?.controls[activeLocationConfiguration]?.controls?.portData?.value?.value?.port?.toString()"
              [serviceStackId]="locationsControl?.controls[activeLocationConfiguration]?.controls?.portData?.value?.value?.serviceStackId">
            </zui-routing-location-item>
          </div>

          <h2 class="__dialog-header">Advanced Location Configuration</h2>

          <!-- Redirect Section -->
          <zui-form-section class="__form-section" separator="none">
            <div *zuiFormSectionTitle>
              <mat-slide-toggle
                [ngrxFormControlState]="locationsControl?.controls[activeLocationConfiguration]?.controls.config.controls.redirect.controls.enabled"
                class="__section-toggle-full">
                Redirect
              </mat-slide-toggle>
            </div>

            <div *zuiFormSectionDesc>
              Automatically redirect requests to this location to a different URL with configurable HTTP status codes and path preservation options.
            </div>

            @if (locationsControl?.controls[activeLocationConfiguration]?.controls.config.controls.redirect.controls.enabled.value) {
              <div class="fx:pt-1">
                <div class="fx:grid fx:grid-cols-1 fx:gap-2">
                <zef-form-field class="__form-field">
                  <mat-form-field color="accent">
                    <mat-label>Redirect Code</mat-label>
                    <input
                      matInput
                      type="number"
                      [ngrxEnableFocusTracking]="true"
                      [ngrxFormControlState]="locationsControl?.controls[activeLocationConfiguration]?.controls.config.controls.redirect.controls.code"
                      placeholder="301" />
                  </mat-form-field>
                </zef-form-field>
              </div>

              <div class="fx:grid fx:grid-cols-1 fx:gap-2">
                <zef-form-field class="__form-field">
                  <mat-form-field color="accent">
                    <mat-label>Redirect URL</mat-label>
                    <input
                      matInput
                      type="text"
                      [ngrxEnableFocusTracking]="true"
                      [ngrxFormControlState]="locationsControl?.controls[activeLocationConfiguration]?.controls.config.controls.redirect.controls.to"
                      placeholder="https://example.com" />
                  </mat-form-field>
                </zef-form-field>
              </div>

              <div class="fx:grid fx:grid-cols-2 fx:gap-2">
                <zef-form-field class="__form-field __toggle-field" [appearance]="'button-toggle'">
                  <zef-form-label>Preserve Path</zef-form-label>
                  <mat-button-toggle-group
                    [ngrxEnableFocusTracking]="true"
                    [ngrxFormControlState]="locationsControl?.controls[activeLocationConfiguration]?.controls.config.controls.redirect.controls.preservePath">
                    <mat-button-toggle [value]="true">On</mat-button-toggle>
                    <mat-button-toggle [value]="false">Off</mat-button-toggle>
                  </mat-button-toggle-group>
                </zef-form-field>

                <zef-form-field class="__form-field __toggle-field" [appearance]="'button-toggle'">
                  <zef-form-label>Preserve Query</zef-form-label>
                  <mat-button-toggle-group
                    [ngrxEnableFocusTracking]="true"
                    [ngrxFormControlState]="locationsControl?.controls[activeLocationConfiguration]?.controls.config.controls.redirect.controls.preserveQuery">
                    <mat-button-toggle [value]="true">On</mat-button-toggle>
                    <mat-button-toggle [value]="false">Off</mat-button-toggle>
                  </mat-button-toggle-group>
                </zef-form-field>
              </div>
              </div>
            }

          </zui-form-section>

          <zui-separator
            spacing="medium"
            orientation="horizontal"
            size="large"
            class="fx:pb-0-75" />

          <!-- Basic Auth Section -->
          <zui-form-section class="__form-section" separator="none">
            <div *zuiFormSectionTitle>
              <mat-slide-toggle
                [ngrxFormControlState]="locationsControl?.controls[activeLocationConfiguration]?.controls.config.controls.basicAuth.controls.enabled"
                class="__section-toggle-full">
                Basic Authentication
              </mat-slide-toggle>
            </div>

            <div *zuiFormSectionDesc>
              Protect this location with username and password authentication. Users will need to provide valid credentials to access this path.
            </div>

            @if (locationsControl?.controls[activeLocationConfiguration]?.controls.config.controls.basicAuth.controls.enabled.value) {
              <div class="fx:pt-1">
                <div class="fx:grid fx:grid-cols-1 fx:gap-2">
                  <zef-form-field class="__form-field">
                    <mat-form-field color="accent">
                      <mat-label>Authentication Realm</mat-label>
                      <input
                        matInput
                        [ngrxFormControlState]="locationsControl?.controls[activeLocationConfiguration]?.controls.config.controls.basicAuth.controls.realm"
                        [ngrxEnableFocusTracking]="true"
                        type="text"
                        placeholder="Restricted Area" />
                    </mat-form-field>
                  </zef-form-field>
                </div>

                <div class="__users-section">
                  <div class="__users-header">
                    <h4 class="__users-title">Users</h4>
                    <button
                      (click)="addBasicAuthUser.emit(activeLocationConfiguration)"
                      type="button"
                      mat-stroked-button
                      class="c-button--smaller">
                      <mat-icon>add</mat-icon>
                      Add User
                    </button>
                  </div>

                  <div class="__users-list">
                    @for (userCtrl of locationsControl?.controls[activeLocationConfiguration]?.controls.config.controls.basicAuth.controls.users?.controls; track $index; let indexInner = $index) {
                      <div class="__user-card-mini">
                        @if (locationsControl?.controls[activeLocationConfiguration]?.controls.config.controls.basicAuth.controls.users?.controls?.length > 1) {
                          <button
                            (click)="removeBasicAuthUser.emit({
                              locationIndex: activeLocationConfiguration,
                              index: indexInner
                            })"
                            type="button"
                            mat-icon-button
                            class="__user-remove-btn">
                            <mat-icon fontSet="material-icons-outlined">delete</mat-icon>
                          </button>
                        }

                        <div class="__user-card-fields">
                          <zef-form-field class="__form-field">
                            <mat-form-field color="accent">
                              <mat-label>Username</mat-label>
                              <input
                                matInput
                                type="text"
                                [ngrxEnableFocusTracking]="true"
                                [ngrxFormControlState]="userCtrl.controls.username"
                                placeholder="admin" />
                            </mat-form-field>
                          </zef-form-field>

                          <zef-form-field class="__form-field">
                            <mat-form-field color="accent">
                              <mat-label>Password</mat-label>
                              <input
                                matInput
                                type="password"
                                [ngrxEnableFocusTracking]="true"
                                [ngrxFormControlState]="userCtrl.controls.password"
                                placeholder="••••••••" />
                            </mat-form-field>
                          </zef-form-field>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            }

          </zui-form-section>

          <zui-separator
            spacing="medium"
            orientation="horizontal"
            size="large"
            class="fx:pb-0-75" />

          <!-- Access Policy Section -->
          <zui-form-section class="__form-section" separator="none">
            <div *zuiFormSectionTitle>
              <mat-slide-toggle
                [ngrxFormControlState]="locationsControl?.controls[activeLocationConfiguration]?.controls.config.controls.accessPolicy?.controls?.enabled"
                class="__section-toggle-full">
                Access Policy
              </mat-slide-toggle>
            </div>

            <div *zuiFormSectionDesc>
              Control access to this location by allowing or denying specific IP addresses and networks.
            </div>

            @if (locationsControl?.controls[activeLocationConfiguration]?.controls.config.controls.accessPolicy?.controls?.enabled?.value) {
              <div class="fx:pt-1">
                <div class="fx:grid fx:grid-cols-1 fx:gap-2">
                <zef-form-field class="__form-field __toggle-field" [appearance]="'button-toggle'">
                  <zef-form-label>Default Policy</zef-form-label>
                  <mat-button-toggle-group
                    [ngrxEnableFocusTracking]="true"
                    [ngrxFormControlState]="locationsControl?.controls[activeLocationConfiguration]?.controls.config.controls.accessPolicy?.controls?.defaultPolicy">
                    <mat-button-toggle value="allow">Allow</mat-button-toggle>
                    <mat-button-toggle value="deny">Deny</mat-button-toggle>
                  </mat-button-toggle-group>
                </zef-form-field>
              </div>

              <div class="fx:grid fx:grid-cols-1 fx:gap-2">
                <zef-form-field class="__form-field">
                  <mat-form-field color="accent">
                    <mat-label>CIDR Blocks (one per line)</mat-label>
                    <textarea
                      matInput
                      [ngrxFormControlState]="locationsControl?.controls[activeLocationConfiguration]?.controls.config.controls.accessPolicy?.controls?.cidr"
                      [ngrxValueConverter]="cidrValueConverter"
                      [ngrxEnableFocusTracking]="true"
                      rows="4"
                      placeholder="192.168.1.0/24&#10;10.0.0.0/8&#10;172.16.0.0/12"></textarea>
                    <mat-hint>Enter IP ranges in CIDR notation. Each range should be on a separate line.</mat-hint>
                  </mat-form-field>
                </zef-form-field>
              </div>
              </div>
            }

          </zui-form-section>

          <zui-separator
            spacing="medium"
            orientation="horizontal"
            size="large"
            class="fx:pb-0-75" />

          <!-- Rate Limiting Section -->
          <zui-form-section class="__form-section" separator="none">
            <div *zuiFormSectionTitle>
              <mat-slide-toggle
                [ngrxFormControlState]="locationsControl?.controls[activeLocationConfiguration]?.controls.config.controls.rateLimiting?.controls?.enabled"
                class="__section-toggle-full">
                Rate Limiting
              </mat-slide-toggle>
            </div>

            <div *zuiFormSectionDesc>
              Limit the number of requests per second to this location to prevent abuse and ensure fair resource usage.
            </div>

            @if (locationsControl?.controls[activeLocationConfiguration]?.controls.config.controls.rateLimiting?.controls?.enabled?.value) {
              <div class="fx:pt-1">
                <div class="fx:grid fx:grid-cols-2 fx:gap-2">
                <zef-form-field class="__form-field">
                  <mat-form-field color="accent">
                    <mat-label>Rate (req/s)</mat-label>
                    <input
                      matInput
                      [ngrxFormControlState]="locationsControl?.controls[activeLocationConfiguration]?.controls.config.controls.rateLimiting?.controls?.rate"
                      [ngrxEnableFocusTracking]="true"
                      type="number"
                      min="1"
                      placeholder="10" />
                    <mat-hint>Requests per second</mat-hint>
                  </mat-form-field>
                </zef-form-field>

                <zef-form-field class="__form-field">
                  <mat-form-field color="accent">
                    <mat-label>Burst</mat-label>
                    <input
                      matInput
                      [ngrxFormControlState]="locationsControl?.controls[activeLocationConfiguration]?.controls.config.controls.rateLimiting?.controls?.burst"
                      [ngrxEnableFocusTracking]="true"
                      type="number"
                      min="1"
                      placeholder="20" />
                    <mat-hint>Maximum burst requests</mat-hint>
                  </mat-form-field>
                </zef-form-field>
              </div>

              <div class="fx:grid fx:grid-cols-2 fx:gap-2">
                <zef-form-field class="__form-field">
                  <mat-form-field color="accent">
                    <mat-label>Zone Name</mat-label>
                    <input
                      matInput
                      [ngrxFormControlState]="locationsControl?.controls[activeLocationConfiguration]?.controls.config.controls.rateLimiting?.controls?.zone"
                      [ngrxEnableFocusTracking]="true"
                      type="text"
                      placeholder="api_limit" />
                    <mat-hint>Unique identifier for this rate limit zone</mat-hint>
                  </mat-form-field>
                </zef-form-field>

                <zef-form-field class="__form-field">
                  <mat-form-field color="accent">
                    <mat-label>Zone Size (MB)</mat-label>
                    <input
                      matInput
                      [ngrxFormControlState]="locationsControl?.controls[activeLocationConfiguration]?.controls.config.controls.rateLimiting?.controls?.zoneSize"
                      [ngrxEnableFocusTracking]="true"
                      type="number"
                      min="1"
                      placeholder="10" />
                    <mat-hint>Memory size for tracking IPs</mat-hint>
                  </mat-form-field>
                </zef-form-field>
              </div>

              <div class="fx:grid fx:grid-cols-1 fx:gap-2">
                <zef-form-field class="__form-field __toggle-field" [appearance]="'button-toggle'">
                  <zef-form-label>Rate Limit Key</zef-form-label>
                  <mat-button-toggle-group
                    [ngrxEnableFocusTracking]="true"
                    [ngrxFormControlState]="locationsControl?.controls[activeLocationConfiguration]?.controls.config.controls.rateLimiting?.controls?.key">
                    <mat-button-toggle value="binary_remote_addr">IP Address</mat-button-toggle>
                    <mat-button-toggle value="server_name">Server Name</mat-button-toggle>
                  </mat-button-toggle-group>
                </zef-form-field>
              </div>
              </div>
            }

          </zui-form-section>

          <zui-separator
            spacing="medium"
            orientation="horizontal"
            size="large"
            class="fx:pb-0-75" />

          <!-- Custom Content Section -->
          <zui-form-section class="__form-section" separator="none">
            <div *zuiFormSectionTitle>
              <mat-slide-toggle
                [ngrxFormControlState]="locationsControl?.controls[activeLocationConfiguration]?.controls.config.controls.content?.controls?.enabled"
                class="__section-toggle-full">
                Custom Content
              </mat-slide-toggle>
            </div>

            <div *zuiFormSectionDesc>
              Serve custom static content or error pages directly from this location instead of proxying to a service.
            </div>

            @if (locationsControl?.controls[activeLocationConfiguration]?.controls.config.controls.content?.controls?.enabled?.value) {
              <div class="fx:pt-1">
                <div class="fx:grid fx:grid-cols-2 fx:gap-2">
                <zef-form-field class="__form-field">
                  <mat-form-field color="accent">
                    <mat-label>HTTP Status Code</mat-label>
                    <mat-select
                      [ngrxFormControlState]="locationsControl?.controls[activeLocationConfiguration]?.controls.config.controls.content?.controls?.code"
                      [ngrxEnableFocusTracking]="true">
                      <mat-option [value]="200">200 - OK</mat-option>
                      <mat-option [value]="404">404 - Not Found</mat-option>
                      <mat-option [value]="403">403 - Forbidden</mat-option>
                      <mat-option [value]="500">500 - Internal Server Error</mat-option>
                      <mat-option [value]="503">503 - Service Unavailable</mat-option>
                    </mat-select>
                  </mat-form-field>
                </zef-form-field>

                <zef-form-field class="__form-field">
                  <mat-form-field color="accent">
                    <mat-label>Content Type</mat-label>
                    <mat-select
                      [ngrxFormControlState]="locationsControl?.controls[activeLocationConfiguration]?.controls.config.controls.content?.controls?.contentType"
                      [ngrxEnableFocusTracking]="true">
                      <mat-option value="text/html">HTML</mat-option>
                      <mat-option value="text/plain">Plain Text</mat-option>
                      <mat-option value="application/json">JSON</mat-option>
                      <mat-option value="text/xml">XML</mat-option>
                    </mat-select>
                  </mat-form-field>
                </zef-form-field>
              </div>

              <div class="fx:grid fx:grid-cols-1 fx:gap-2">
                <zef-form-field class="__form-field">
                  <mat-form-field color="accent">
                    <mat-label>Content</mat-label>
                    <textarea
                      matInput
                      [ngrxFormControlState]="locationsControl?.controls[activeLocationConfiguration]?.controls.config.controls.content?.controls?.content"
                      [ngrxEnableFocusTracking]="true"
                      rows="6"
                      placeholder="<!DOCTYPE html>&#10;<html>&#10;<head><title>Custom Page</title></head>&#10;<body>&#10;<h1>Custom Content</h1>&#10;</body>&#10;</html>"></textarea>
                    <mat-hint>The content to return for this location</mat-hint>
                  </mat-form-field>
                </zef-form-field>
              </div>
              </div>
            }

          </zui-form-section>

        </zef-form>
      }
    </zef-scrollbar>

  </div>

  <div class="__dialog-buttons">
    <button
      mat-stroked-button
      [disabled]="!locationsControl.isValid"
      color="accent"
      class="c-button"
      (click)="applyCloseAdvancedConfig()">
      <span class="fx:pr-0-25">Apply configuration to location</span><mat-icon>east</mat-icon>
    </button>
  </div>

</zef-dialog>
